import React, { Component } from "react";
import Popup from "reactjs-popup";
import request from "../constants/requests";
import {Button, CircularProgress} from "@material-ui/core";


class RegisterPopUp extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isFetching: false
        };

        this.onRegister = this.onRegister.bind(this);
    }

    onRegister() {
        this.setState({ isFetching: true });
        const registerRequest = fetch(request.REGISTER(), {
            method: 'POST',
            headers: request.HEADER(),
            body: JSON.stringify({ idToken: this.props.googleTokenId })
        });
        registerRequest.then((res) => {
            this.setState({ isFetching: false });
            res.json().then((response) => {
                if(response.didLoginSuccess) {
                    // if register/login successfully, show the screen
                    this.props.onRegister(response.token);
                }
            }, (err) => {
                console.log(err);
                console.log("Parsing response body failed.");
            });
        }, (err) => {
            this.setState({ isFetching: false });
            console.log(err);
            console.log("Register request failed.")
        });
    }

    render() {
        return (
            <Popup
                open={ true }
                closeOnDocumentClick={ false }
            >
                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center',
                    marginTop: 30, marginBottom: 30 }}>
                    <div>
                        You have to register in order to use Triton Plan Pro
                    </div>
                    <div style={{ marginTop: 35, marginBottom: 10 }}>
                        {
                            this.state.isFetching
                                ? <CircularProgress size={24} />
                                : <Button variant={'contained'} onClick={ this.onRegister }>Register</Button>
                        }
                    </div>
                    <div style={{ fontSize: 11, display: 'flex' }}>
                        *By clicking "Register", you agree to our
                        <a style={{ marginLeft: 3 }} href={request.TERMS_AND_SERVICES()} target={ "_blank" }>
                            Terms and Services
                        </a>
                        .
                    </div>
                </div>
            </Popup>
        );
    }
}

export default RegisterPopUp;